import Box from './list';
import './list.sass';

export default Box;
